import { Box, Typography, Container, Button } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";

function Schedule({ hasIntroductionRendered }) {
  const scheduleTitleRef = useRef(null);
  const ceremonyRef = useRef(null);
  const separatorRef = useRef(null);
  const receptionRef = useRef(null);

  const { animationStarted } = useAnimation();

  const scheduleTitleInView = useInView(scheduleTitleRef, {
    once: true,
    margin: "0px",
  });
  const ceremonyInView = useInView(ceremonyRef, { once: true, margin: "0px" });
  const separatorInView = useInView(separatorRef, {
    once: true,
    margin: "0px",
  });
  const receptionInView = useInView(receptionRef, {
    once: true,
    margin: "0px",
  });

  const ceremonyGoogleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=Casamento+-+Isabela+%26+Tiago&dates=20260704T160000/20260705T040000&details=Cerimónia+de+casamento&location=Igreja+de+São+Quintino,+Largo+Dom+Manuel+Primeiro,+2590-022&sf=true&output=xml`;

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 2 }}>
      <Typography
        component={motion.h5}
        ref={scheduleTitleRef}
        initial={{ opacity: 0, y: 40 }}
        align="center"
        animate={
          scheduleTitleInView && animationStarted && hasIntroductionRendered
            ? { opacity: 1, y: 0 }
            : { opacity: 0, y: 40 }
        }
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        variant="h5"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1.35rem", sm: "1.5rem" },
          fontWeight: 600,
          color: "#1a3a52",
          mb: 4,
          letterSpacing: "0.5px",
        }}
      >
        Sobre o Nosso Dia
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: { xs: 2, sm: 4 },
        }}
      >
        {/* Event 1: Cerimónia */}
        <Box
          component={motion.div}
          ref={ceremonyRef}
          initial={{ opacity: 0, y: 40 }}
          animate={
            ceremonyInView && animationStarted && hasIntroductionRendered
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 40 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            textAlign: "center",
            mb: 4,
            maxWidth: "500px",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.9rem", sm: "1rem" },
              fontWeight: 400,
              color: "#2d4e66",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              mb: 1.5,
            }}
          >
            16:00 – 17:30
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1.5rem", sm: "1.75rem" },
              fontWeight: 400,
              color: "#1a3a52",
              letterSpacing: "0.5px",
              mb: 1.5,
            }}
          >
            Cerimónia
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              fontWeight: 300,
              color: "#1a3a52",
              mb: 0.5,
            }}
          >
            IGREJA DE SÃO QUINTINO
          </Typography>

          <Typography
            component="a"
            href="https://www.google.com/maps/place/Igreja+de+S%C3%A3o+Quintino/@39.0056492,-9.1442519,17z/data=!4m15!1m8!3m7!1s0xd18d45598ea1a43:0xd5773df3e22bd68d!2sLargo+Dom+Manuel+Primeiro!3b1!8m2!3d39.0056492!4d-9.1442519!16s%2Fg%2F119vsfx40!3m5!1s0xd18d455a0c04b7b:0xdd87a943ed3911d5!8m2!3d39.0060168!4d-9.1442517!16s%2Fm%2F0h7q70j?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.95rem", sm: "1rem" },
              fontWeight: 300,
              color: "#2d4e66",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
                color: "#1a3a52",
              },
            }}
          >
            Largo Dom Manuel Primeiro, 2590-022
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              component="a"
              href="https://www.google.com/maps/place/Igreja+de+S%C3%A3o+Quintino/@39.0056492,-9.1442519,17z/data=!4m15!1m8!3m7!1s0xd18d45598ea1a43:0xd5773df3e22bd68d!2sLargo+Dom+Manuel+Primeiro!3b1!8m2!3d39.0056492!4d-9.1442519!16s%2Fg%2F119vsfx40!3m5!1s0xd18d455a0c04b7b:0xdd87a943ed3911d5!8m2!3d39.0060168!4d-9.1442517!16s%2Fm%2F0h7q70j?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#1a3a52",
                borderColor: "#1a3a52",
                textTransform: "none",
                px: 3,
                py: 1,
                width: "220px",
                "&:hover": {
                  borderColor: "#1a3a52",
                  backgroundColor: "rgba(26, 58, 82, 0.04)",
                },
              }}
            >
              Google Maps
            </Button>
            <Button
              component="a"
              href={ceremonyGoogleCalendarUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#1a3a52",
                borderColor: "#1a3a52",
                textTransform: "none",
                px: 3,
                py: 1,
                width: "220px",
                "&:hover": {
                  borderColor: "#1a3a52",
                  backgroundColor: "rgba(26, 58, 82, 0.04)",
                },
              }}
            >
              Adicionar ao Calendário
            </Button>
          </Box>
        </Box>

        {/* Separator */}
        <Box
          component={motion.div}
          ref={separatorRef}
          initial={{ opacity: 0, scaleY: 0 }}
          animate={
            separatorInView && animationStarted && hasIntroductionRendered
              ? { opacity: 0.3, scaleY: 1 }
              : { opacity: 0, scaleY: 0 }
          }
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            width: "2px",
            height: "40px",
            backgroundColor: "#2d4e66",
            mb: 4,
          }}
        />

        {/* Event 2: Copo de Água */}
        <Box
          component={motion.div}
          ref={receptionRef}
          initial={{ opacity: 0, y: 40 }}
          animate={
            receptionInView && animationStarted && hasIntroductionRendered
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 40 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            textAlign: "center",
            maxWidth: "500px",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.9rem", sm: "1rem" },
              fontWeight: 400,
              color: "#2d4e66",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              mb: 1.5,
            }}
          >
            18:00 – 04:00
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1.5rem", sm: "1.75rem" },
              fontWeight: 400,
              color: "#1a3a52",
              letterSpacing: "0.5px",
              mb: 1.5,
            }}
          >
            Copo de Água
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              fontWeight: 300,
              color: "#1a3a52",
              mb: 0.5,
            }}
          >
            QUINTA DE D. CARLOS
          </Typography>

          <Typography
            component="a"
            href="https://www.google.com/maps/place/Quinta+de+D.+Carlos/@39.0745024,-9.0443447,17z/data=!3m1!4b1!4m6!3m5!1s0xd18d0e9c20eaf35:0x6dadf69178a8de16!8m2!3d39.0745024!4d-9.0417698!16s%2Fg%2F11c0vxfgjq?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.95rem", sm: "1rem" },
              fontWeight: 300,
              color: "#2d4e66",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
                color: "#1a3a52",
              },
            }}
          >
            N9 3, Carvoeira
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              component="a"
              href="https://www.google.com/maps/place/Quinta+de+D.+Carlos/@39.0745024,-9.0443447,17z/data=!3m1!4b1!4m6!3m5!1s0xd18d0e9c20eaf35:0x6dadf69178a8de16!8m2!3d39.0745024!4d-9.0417698!16s%2Fg%2F11c0vxfgjq?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#1a3a52",
                borderColor: "#1a3a52",
                textTransform: "none",
                px: 3,
                py: 1,
                width: "220px",
                "&:hover": {
                  borderColor: "#1a3a52",
                  backgroundColor: "rgba(26, 58, 82, 0.04)",
                },
              }}
            >
              Google Maps
            </Button>
            <Button
              component="a"
              href={ceremonyGoogleCalendarUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#1a3a52",
                borderColor: "#1a3a52",
                textTransform: "none",
                px: 3,
                py: 1,
                width: "220px",
                "&:hover": {
                  borderColor: "#1a3a52",
                  backgroundColor: "rgba(26, 58, 82, 0.04)",
                },
              }}
            >
              Adicionar ao Calendário
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default Schedule;
